import { CLAUDE_PROMPTS } from "@/rbac/links.js";

import {
  VIEW_CLAUDE_PROMPT,
  CREATE_CLAUDE_PROMPT,
  UPDATE_CLAUDE_PROMPT,
} from "@/rbac/permissions.js";

function props(route) {
  let orderByDefault = route.query.order_by_created_at || "asc";

  if (
    route.query.order_by_id ||
    route.query.order_by_system_id ||
    route.query.order_by_name ||
    route.query.order_by_version ||
    route.query.order_by_description ||
    route.query.order_by_is_active_name ||
    route.query.order_by_is_system_name ||
    route.query.order_by_updated_at
  ) {
    orderByDefault = null;
  }

  return {
    page: parseInt(route.query.page) || 1,
    limit: parseInt(route.query.limit) || 10,

    id: parseInt(route.query.id) || null,
    order_by_id: route.query.order_by_id || null,

    system_id: route.query.system_id || null,
    order_by_system_id: route.query.order_by_system_id || null,

    created_by_user_id: parseInt(route.query.created_by_user_id) || null,
    order_by_created_by_user_id:
      route.query.order_by_created_by_user_id || null,

    updated_by_user_id: parseInt(route.query.updated_by_user_id) || null,
    order_by_updated_by_user_id:
      route.query.order_by_updated_by_user_id || null,

    name: route.query.name || null,
    order_by_name: route.query.order_by_name || null,

    description: route.query.description || null,
    order_by_description: route.query.order_by_description || null,

    version: route.query.version || null,
    order_by_version: route.query.order_by_version || null,

    is_active: route.query.is_active ? parseInt(route.query.is_active) : null,
    order_by_is_active_name: route.query.order_by_is_active_name || null,

    is_system: route.query.is_system ? parseInt(route.query.is_system) : null,
    order_by_is_system_name: route.query.order_by_is_system_name || null,

    order_by_created_at: orderByDefault,
    order_by_updated_at: route.query.order_by_updated_at || null,
  };
}

const claudePromptRoutes = [
  {
    path: "/nacd-ai-prompts",
    component: () =>
      import(
        /* webpackChunkName: "system-layout" */ "@/views/system/Layout.vue"
      ),
    children: [
      {
        path: "",
        name: "ClaudePromptIndex",
        meta: {
          title: "NACD AI Prompts",
          permission: CLAUDE_PROMPTS,
        },
        props: (route) => props(route),
        component: () =>
          import(
            /* webpackChunkName: "claude-prompt-index" */ "@/views/system/claude-prompt/Index.vue"
          ),
      },
      {
        path: "create",
        name: "ClaudePromptCreate",
        meta: {
          title: "Create NACD AI Prompt",
          permission: CREATE_CLAUDE_PROMPT,
        },
        component: () =>
          import(
            /* webpackChunkName: "claude-prompt-create" */ "@/views/system/claude-prompt/Create.vue"
          ),
      },
      {
        path: ":id/view",
        name: "ClaudePromptView",
        meta: {
          title: "View NACD AI Prompt",
          permission: VIEW_CLAUDE_PROMPT,
        },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "claude-prompt-view" */ "@/views/system/claude-prompt/View.vue"
          ),
      },
      {
        path: ":id/edit",
        name: "ClaudePromptEdit",
        meta: {
          title: "Edit NACD AI Prompt",
          permission: UPDATE_CLAUDE_PROMPT,
        },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "claude-prompt-edit" */ "@/views/system/claude-prompt/Edit.vue"
          ),
      },
    ],
  },
];

export default claudePromptRoutes;
